module.exports = __webpack_public_path__ + "static/partnerships_label.29e09f91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Sponsors/partnerships_label.svg
// module id = 737
// module chunks = 213534597649335